import { useEffect } from 'react';
import LucideSymbolIcon from '../icons/LucideSymbolIcon';

interface AdminToastProps {
  message: string | null;
  variant?: 'success' | 'error';
  onClose: () => void;
}

export default function AdminToast({ message, variant = 'success', onClose }: AdminToastProps) {
  useEffect(() => {
    if (!message) {
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      onClose();
    }, 3000);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [message, onClose]);

  if (!message) {
    return null;
  }

  const isError = variant === 'error';

  return (
    <div
      className={[
        'fixed right-6 top-24 z-[100] max-w-sm rounded-xl px-4 py-3 text-sm font-medium text-white shadow-2xl',
        isError ? 'border border-error/40 bg-red-900' : 'border border-tertiary-fixed/30 bg-slate-900',
      ].join(' ')}
    >
      <div className="flex items-start gap-3">
        <LucideSymbolIcon
          name={isError ? 'error' : 'check_circle'}
          tone="inherit"
          className={isError ? 'text-red-200' : 'text-emerald-300'}
          size={22}
        />
        <div className="flex-1">{message}</div>
        <button type="button" onClick={onClose} className="text-white/70 transition hover:text-white">
          <LucideSymbolIcon name="close" tone="inherit" className="text-white/80" size={18} />
        </button>
      </div>
    </div>
  );
}
